module.exports = __webpack_public_path__ + "img/visalogo.2e4a29e7.png";